import { h } from 'vue'
import type { IconSet, IconProps } from 'vuetify'

import 'material-symbols/rounded.css'

const materialSymbols: IconSet = {
  component: (props: IconProps) =>
    h(
      props.tag as string,
      { class: 'material-symbols-rounded', style: 'font-size: inherit; line-height: inherit; vertical-align: middle;' },
      [props.icon as string],
    ),
}

export const materialSymbolsAliases: Record<string, string> = {
  // Vuetify internal aliases
  checkboxOn: 'check_box',
  checkboxOff: 'check_box_outline_blank',
  checkboxIndeterminate: 'indeterminate_check_box',
  clear: 'cancel',
  expand: 'keyboard_arrow_down',
  collapse: 'keyboard_arrow_up',
  complete: 'check',
  cancel: 'cancel',
  close: 'close',
  delete: 'delete',
  delimiter: 'circle',
  sort: 'arrow_upward',
  loading: 'cached',
  first: 'first_page',
  last: 'last_page',
  unfold: 'unfold_more',
  file: 'attach_file',
  plus: 'add',
  minus: 'remove',
  dropdown: 'keyboard_arrow_down',
  radioOn: 'radio_button_checked',
  radioOff: 'radio_button_unchecked',
  edit: 'edit',
  ratingEmpty: 'star_border',
  ratingFull: 'star',
  ratingHalf: 'star_half',
  subgroup: 'arrow_drop_down',
  success: 'check_circle',
  info: 'info',
  warning: 'warning',
  error: 'error',
  prev: 'chevron_left',
  next: 'chevron_right',
  goBack: 'arrow_back',
  goForward: 'arrow_forward',
  calendar: 'calendar_today',
  treeviewCollapse: 'keyboard_arrow_down',
  treeviewExpand: 'keyboard_arrow_right',
  tableGroupCollapse: 'keyboard_arrow_down',
  tableGroupExpand: 'keyboard_arrow_right',
  eyeDropper: 'colorize',
  menu: 'menu',
  // sort icons used in VDataTable
  sortAsc: 'arrow_upward',
  sortDesc: 'arrow_downward',
}

export default materialSymbols
